import { render, staticRenderFns } from "./EventGetTransfer.vue?vue&type=template&id=6ea8f1bb&"
import script from "./EventGetTransfer.vue?vue&type=script&lang=js&"
export * from "./EventGetTransfer.vue?vue&type=script&lang=js&"
import style0 from "./EventGetTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VFlex,
  VLayout,
})
